import { useDispatch, useSelector } from 'react-redux'
import * as PageAction from 'actions/PageAction' // 共通部分が多いActionはActionCreaterにまとめる
import { useCallback } from 'react'
import { voidF, voidStringF } from 'types/FunctionTypes'

// メッセージ //================================//
export const usePageMessage = (): [voidStringF, voidF] => {
  const dispatch = useDispatch()
  const changePageErrorMessage = useCallback((text: string) => {
    dispatch(PageAction.changeErrorMessage(text))
  }, [])
  const deletePageMessage = useCallback(() => {
    dispatch(PageAction.deleteMessage())
  }, [])
  return [changePageErrorMessage, deletePageMessage]
}

/**
 * ローディング //================================//
 */
export const useLoading = (): [boolean, (load: boolean) => void] => {
  const dispatch = useDispatch()
  // ローディング
  const loading = useSelector((state) => state.PageReducer.loading)
  const changeLoading = useCallback(
    (load: boolean) => {
      dispatch(PageAction.changeLoading(load))
    },
    [loading],
  )

  return [loading, changeLoading]
}
